<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="computedHeaders"
    :table-items="activities"
    :indexNested="true"
    :disablePagination="true"
    :maskFields="maskFields"
    :hasTableTitle="true"
  >
    <template slot="new" v-if="!readOnly">
      <New
        @entry-created="entryCreated"
        :withPatrimonies="withPatrimonies"
        :initialDate="initialDate"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="show" slot-scope="{ item }">
      <Edit
        :entry="item"
        :readOnly="true"
        :withPatrimonies="withPatrimonies"
        :initialDate="initialDate"
        :modelNameSingular="modelNameSingular"
      />
    </template>

    <template slot="edit" v-if="!readOnly" slot-scope="{ item }">
      <Edit
        :entry="item"
        @entry-updated="entryUpdated"
        :withPatrimonies="withPatrimonies"
        :initialDate="initialDate"
        :modelNameSingular="modelNameSingular"
        :isEdit="true"
      />
    </template>

    <template slot="delete" v-if="!readOnly" slot-scope="{ item }">
      <Delete
        :entry="item"
        @entry-destroyed="entryDeleted"
        :initialDate="initialDate"
        :modelNameSingular="modelNameSingular"
      />
    </template>

  </BaseIndex>
</template>

<script>
import BaseIndex from "@shared_components/base_index.vue";
import New from "./new.vue";
import Edit from "./edit.vue";
import Delete from "./delete.vue";

export default {
  data() {
    return {
      loading: false,
      pageLoading: false,
      indexKey: 1,
      tableHeaders: [
        { text: "Funcionário", align: "left", sortable: true, value: "person.name", showOnlyWithPatrimonies: false},
        { text: "Duração", align: "left", sortable: true, value: "durationText", showOnlyWithPatrimonies: false },
        { text: "Início", align: "left", sortable: true, value: "startDate", showOnlyWithPatrimonies: false },
        { text: "Término", align: "left", sortable: true, value: "endDate", showOnlyWithPatrimonies: false },
        { text: "Patrimônio", align: "left", sortable: true, value: "patrimony.description", showOnlyWithPatrimonies: true },
        { text: "Implemento", align: "left", sortable: true, value: "implement.description", showOnlyWithPatrimonies: true },
        { text: "Ações", value: "action", sortable: false }
      ],
      maskFields: [
        { field: 'startDate', mask: 'date' },
        { field: 'endDate', mask: 'date' },
        // { field: 'price', mask: 'currency_10d' },
        // { field: 'quantity', mask: 'number' },
        // { field: 'totalPrice', mask: 'currency' }
      ]
    };
  },
  components: {
    BaseIndex: BaseIndex,
    New: New,
    Edit: Edit,
    Delete: Delete,
  },
  props: {
    activities: {
      type: Array,
      default: () => []
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    withPatrimonies: {
      type: Boolean,
      default: true
    },
    initialDate: {
      type: String,
      default: null
    },
    modelNameSingular: {
      type: String,
      default: "Atividade"
    },
    modelNamePlural: {
      type: String,
      default: "Atividades"
    },
  },
  created() {
  },
  computed : {
    computedHeaders () {
      return this.tableHeaders.filter(column => this.withPatrimonies || !column.showOnlyWithPatrimonies)
    }
  },
  methods: {
    entryUpdated: function(editedEntry){
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(editedEntry){
      this.activities.push(editedEntry);
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(editedEntry){
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
  }
};
</script>

<style scoped></style>
